import React from 'react'
import cx from 'classnames'

import { CheckboxCell } from 'components/shared/Table/common/Cells/CheckboxCell/CheckboxCell'

import styles from './TableRow.module.scss'

export const TableRow = ({
  children,
  className = undefined,
  type,
  onChange,
  hasCheckbox,
  isChecked = false,
  isIndeterminate = false,
  isSelected = false,
  isHighlighted = false,
  isInactive = false,
  isDisabled = false,
  hide = false,
}) => (
  <tr
    className={cx(styles.row, {
      [styles.selected]: isSelected,
      [styles.highlighted]: isHighlighted,
      [styles.inactive]: isInactive,
      [className]: Boolean(className),
    })}
  >
    {hasCheckbox && !hide && (
      <CheckboxCell
        className={styles.checkbox}
        {...{ type, onChange, isChecked, isDisabled, isIndeterminate }}
      />
    )}
    {hide ? null : children}
  </tr>
)
